import { FlexProps, useModal } from '@wrisk/ui-components'
import React, { FunctionComponent, useCallback } from 'react'
import { useNavigate } from 'react-router'

import { getFirstInceptedDate, getPolicyToEndAt, getPolicyVersion } from '../../../domain'
import { useIsMtaAllowed } from '../../../hooks/adjustments/policy/renewal'
import { ProductKind } from '../../../state/configuration'
import { PolicyPath } from '../../product/policy/PolicyPath'
import { usePolicy } from '../../product/policy/PolicyProvider'
import { useProduct } from '../../product/ProductProvider'
import { InRenewalMtaBlockedModal } from '../InRenewalMtaBlockedModal'
import { QuoteDetailsView } from '../quote'

export const PolicyDetailsView: FunctionComponent<FlexProps> = (props) => {
  const navigate = useNavigate()

  const { product } = useProduct()
  const { policy } = usePolicy()

  const { quote } = getPolicyVersion(policy)

  const modal = useModal()
  const isMtaAllowed = useIsMtaAllowed()

  const onEdit = useCallback(() => {
    isMtaAllowed
      ? navigate(PolicyPath.MANAGEMENT)
      : modal.show({
          content: <InRenewalMtaBlockedModal />,
        })
  }, [isMtaAllowed, modal, navigate])

  const startAt = getFirstInceptedDate(policy)

  const endAt =
    product.productKind === ProductKind.SUBSCRIPTION
      ? undefined
      : getPolicyToEndAt(policy)

  return (
    <QuoteDetailsView
      onEdit={onEdit}
      quote={quote}
      startAt={startAt}
      endAt={endAt}
      {...props}
    />
  )
}
